import { ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../Dashboad.service';
import { EmployeeService } from '../../employee-profile/employee-profile.service';
import { ToastrService } from 'ngx-toastr';
import { SharedSkillService } from '../../skill-repository/shared-skill.service';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { GsdRoles } from 'src/app/enums/gsdRoles.enum';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { debug } from 'console';
import { EmployeeModel } from 'src/app/Models/EmpCareerUser.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { P } from '@angular/cdk/keycodes';
import { EmployeeOnboardingComponent } from '../employee-onboarding/employee-onboarding.component';

@Component({
  selector: 'app-profile-card',
  templateUrl: './profile-card.component.html',
  styleUrls: ['./profile-card.component.css']
})
export class ProfileCardComponent implements OnInit {
  data: any;
  employeeId: number;
  newemployeeId: number;
  userId: any;
  employeeInfo: any;
  employeeProfileInfo: any;
  courseCompleted: number = 0;
  totalCourses: number = 0;
  programPendingRequestCount: number = 0;
  myBadges: number = 0;
  completedCertificates: number = 0;
  exp: any;
  expYears: any;
  employeeCareerUserDetails?: EmployeeModel;
  expMonths: any;
  isProjectAllocated: boolean = true;
  loading: boolean = false;
  employee: any;
  employeeProfileBasicStatus: any;
  LeadershipRole: boolean;
  competencyLeaderRole: boolean;
  roles: any;
  empId: string;
  resumeMessage: string;
  completedProgramscount: number = 0;
  totalProgramscount: number = 0;
  disableEditpage: boolean;
  showeditbutton: boolean= false;
  isInPool : boolean;
  statusDescriptions: any = ["Reach out to GSD team,they will add you to a Competency"];
  @Input() programRequestsCount: number;

  @Input() isManager: boolean = false;
  @Input() overallTeamPrograms: number;
  @Input() overallTeamCompletedPrograms: number;
  @Input() teamprogramRequestsCount: number;
  @Input() isViewTeamDashboard: boolean = false;
  @Input() totalProjects: any;
  @Input() empReporting: number;
  @Input() billableEmps: number;
  @Input() shadowEmps: number;
  @Input() empsProjectStatus: any;
  @Input() teamCertificationCount: number = 0;
  @Input() userEmpId:number;

  constructor(private router: Router, private service: DashboardService, private employeeService: EmployeeService, private toastr: ToastrService, private shareSkillService: SharedSkillService, private auth: AuthServiceService, private dialog: MatDialog, private cdRef: ChangeDetectorRef) {

  }

  ngOnInit() {
    
    this.newemployeeId = parseInt(localStorage.getItem('Id'));
    if(this.userEmpId==0 || !this.userEmpId)
    {
      this.employeeId = parseInt(localStorage.getItem('Id'));
    }
    else{
      this.employeeId = this.userEmpId;
    }
    if(this.newemployeeId == this.employeeId)
    {
      this.showeditbutton=true;
    }
    this.getEmployeeBasicDetails(this.employeeId);
    this.getProfileDetailsById();
    this.updateInPoolStatus();
    setTimeout(() => this.FetchProgramCourseTopicsData(parseInt(localStorage.getItem('EmpCareerUserID'))), 1000);
  }

  openDialog(employeeId: any) {
    
    this.dialog.open(ProfileCardDialog, {
      height: '85%',
      width: '60%',
      data: { empId: employeeId }
    });
  }
  ngAfterContentChecked() {
    this.cdRef.detectChanges();
  }

  FetchProgramCourseTopicsData(userId: number) {
    this.service.FetchProgramCourseTopicsData(userId).subscribe(data => {
      if (data && data.length > 0) {
        this.completedProgramscount = data[0].completedPrograms ?? 0;
        this.totalProgramscount = data[0].totalPrograms
      }
    });
  }
  redirectToPage(page: string) {
    this.roles = this.auth.getRole();
    if (this.roles.includes(GsdRoles.CompetencyLeader) || this.roles.includes(GsdRoles.SubCompetencyLeader) || this.roles.includes(GsdRoles.SuperAdmin)) {
      this.competencyLeaderRole = true;
    } if (this.roles.includes(GsdRoles.Leadership)) {
      this.LeadershipRole = true;
    }
    if (this.competencyLeaderRole || this.LeadershipRole) {
      this.router.navigate(["Home/Dashboard/Profile View"])
    }
    else {
      this.router.navigate(["Dashboard/Profile View"])
    }
  }
  GetUserProgramDetailsByEmployeeId(employeeId: number) {
    this.service.GetUserProgramDetailsByEmployeeId(employeeId).subscribe(x => {
      this.data = x.value;
      this.courseCompleted = this.data.courseCompleted;
      this.totalCourses = this.data.totalCourses;
      this.programPendingRequestCount = this.data.programPendingRequestCount;
      this.myBadges = this.data.myBadges;
      this.userId = this.data.userId;
      localStorage.setItem('userId', this.userId);


    });
  }

  getEmployeeBasicDetails(empId?: number) {
    if (empId) {
      this.loading = true;
      this.employeeService.getEmployeeDetails(empId).subscribe(
        (res) => {
          this.employee = res.data;
          this.cdRef.detectChanges();
          this.employee?.competencies?.forEach(c => {
            c.subCompetencies.forEach(s => {
              s.certificates.forEach(cert => {
                if (cert.status == 3) {
                  this.completedCertificates += 1
                }
              })
            })
          })
          if (this.employee.competencies != null && this.employee.competencies[0].subCompetencies != null) {          
            this.disableEditpage = false;
          }
          else {            
            this.disableEditpage = true;
            // this.naviagateToEmployeeOnboarding();
          }
          this.employeeProfileBasicStatus = this.employee.employeeProfileStatus;
          this.loading = false;
          this.resumeMessage = this.employee.resume !== null ? 'Profile Uploaded' : 'Profile Not Uploaded';
        },
        (error) => {
          console.error('Error fetching employee details:', error);
          this.loading = false;
        }
      );
    }
  }

  updateInPoolStatus() {
    if(this.employee && this.employeeProfileInfo){
      this.isInPool = this.employee?.isProjectAllocated === false && this.employeeProfileInfo?.isDeleted === false;
    }
  }

  getProfileDetailsById() {
    this.employeeService.GetProfileDetailsById(this.employeeId).subscribe(res => {

      if (res.data) {
        this.employee = res.data;
        this.employeeProfileInfo = res.data;
        this.exp = this.employeeProfileInfo.experience;
        this.expYears = Math.floor(this.exp);
        this.expMonths = Math.round((this.exp - this.expYears) * 12);

      }
      else {
        this.toastr.warning("No Data of employee");
      }
    });
  }
  naviagateToEmployeeDetails() {
    this.shareSkillService.setEmployeeId(this.employeeId)
    this.shareSkillService.setMode(false)
    this.router.navigate([`Employee-details/${this.employeeId}`]);

  }

  naviagateToEmployeeOnboarding() {
    const dialogRef = this.dialog.open(EmployeeOnboardingComponent, {
      maxHeight: '545px',
      minHeight: '369px',
      width: '70%'
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'accept') {
       this.getEmployeeBasicDetails(Number(this.employeeId));
        this.cdRef.detectChanges();

      } else if (result === 'submit') {
        // this.showSuccessMessage();
        this.toastr.info(
          'Your competency adjustment request has been submitted for review. You will be notified via email once processed.', 
          '',
          {
            positionClass: 'toast-top-center', 
            toastClass: 'ngx-toastr wide-notification',
            messageClass: 'toast-message'
          }
        );
      }
    });
  }
  showSuccessMessage() {
    this.toastr.success('Your competency adjustment request has been submitted for review. You will be notified via email once processed.', 
    '', {
      closeButton: true,
      positionClass: 'toast-top-center',  
      enableHtml: true, // Allows custom HTML
      toastClass: 'custom-toast-success',
    });
  }
  handleNavigation() {
    if (this.disableEditpage) {
      this.naviagateToEmployeeOnboarding();
    }
    else {
      this.naviagateToEmployeeDetails();
    }
  }


  cardColor: string = '#FFF';
  cardText: string;
  cardTextColor: string;
  getTooltipText(status: number | undefined): string {
    if (status === 1) {
      // this.cardColor = '#BEE2FD';
      this.cardTextColor = '#036CA7';
      this.cardText = 'S';
      return 'Your profile has been submitted';
    } else if (status === 2) {
      //this.cardColor = '#E4EAEE';
      this.cardTextColor = '#585858';
      this.cardText = 'N';
      return 'Your profile is not submitted';
    } else if (status === 3) {
      //this.cardColor = '#c9ecd9';
      this.cardTextColor = '#007e3a';
      this.cardText = 'A';
      return 'Your Profile is approved';
    }
    else if (status === 4) {
      //this.cardColor = '#FFCCCB';
      this.cardTextColor = '#E92C2C';
      this.cardText = 'R';
      return 'Your profile is rejected';
    }
    else {
      this, this.cardText = 'U';
      return 'Unknown Status';
    }
  }

  goToAssignedToMe() {
    this.router.navigateByUrl('Home/employee-career/employee-Career-program', { state: { Status: '2' } });
  }
  goToMyRequestsPage() {
    this.router.navigateByUrl('Home/employee-career/employee-Career-request/my-requests', { state: { activeTab: 1 } });
  }
  goToTeamRequestsPage() {
    this.router.navigateByUrl('Home/employee-career/employee-Career-request/team-requests');
  }
  getTooltipTextProfile(text: string): string {
    if (text === "projects") {
      if (this.totalProjects.length === 0) {
        return '<p class="tooltipData mb-0">No projects available.</p>';
      }
      let tooltipText: any = '';
      for (const project of this.totalProjects) {
        tooltipText += `<p class="tooltipData mb-0">● ${project.Name}</p>`;
      }
      return tooltipText;
    }
    if (text === "empReporting") {
      if (this.totalProjects.length === 0) {
        return '<p class="tooltipData mb-0">No reporting employees.</p>';
      }
      let tooltipText = '';
      for (const project of this.totalProjects) {
        tooltipText += `<p class="tooltipData mb-0">● ${project.Name} - ${project.Employees}</p>`;
      }
      return tooltipText;
    }
    if (text === "billableEmps") {
      if (this.totalProjects.length === 0) {
        return '<p class="tooltipData mb-0">No billable employees.</p>';
      }
      let tooltipText = '';
      for (const project of this.empsProjectStatus) {
        tooltipText += `<p class="tooltipData mb-0">● ${project.Name} - ${project.Billable}</p>`;
      }
      return tooltipText;
    }
    if (text === "shadowEmps") {
      if (this.totalProjects.length === 0) {
        return '<p class="tooltipData mb-0">No shadow employees.</p>';
      }
      let tooltipText = '';
      for (const project of this.empsProjectStatus) {
        tooltipText += `<p class="tooltipData mb-0">● ${project.Name} - ${project.Shadow}</p>`;
      }
      return tooltipText;
    }
  }
  teamCourseDetailsNavigate() {
    this.router.navigateByUrl('Home/Dashboard/Team Program Details', { state: { Status: [2] } })
  }

}

//Dialog
@Component({
  selector: 'profile-card-dialog',
  templateUrl: 'profile-card-dialog.html',
  styleUrls: ['./profile-card.component.css']
})
export class ProfileCardDialog implements OnInit {
  employeeId: number;
  exp: any;
  expYears: any;
  expMonths: any;
  loading: boolean = false;
  employee: any;
  employeeProfileBasicStatus: any;
  competency: any;
  competency1: any;
  domains: any;
  certifications: any;
  subCompetencyName: any;
  subCompetencyName1: any;
  experience: number = 0;
  expDomains: any[] = [];
  expAreas: any[] = []
  empAreaExps: any;
  primarySkills: any[] = [];
  primarySkill: any[] = [];
  empExpArea: any[] = [];
  empAreaExp: any[] = [];
  empAreaAndExp: any[] = [];
  expAreaMonths: any[] = [];
  expAreaMonth: any[] = [];
  expAreaYears: any[] = [];
  expAreaYear: any[] = [];
  empExperience: string;
  lastName: string;
  firstName: string;
  grade: string;
  designation: string;
  employeeProfileStatus: string;
  constructor(private router: Router, private service: DashboardService, private employeeService: EmployeeService, private toastr: ToastrService, private shareSkillService: SharedSkillService, private auth: AuthServiceService, private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, private spinner: NgxSpinnerService,
  ) {

  }

  ngOnInit() {
    
    this.employeeId = this.data.empId ?? parseInt(localStorage.getItem('Id'));
    this.getProfileDetailsById(this.employeeId)
  }
  getProfileDetailsById(empId?: number) {
    if (empId) {
      this.loading = true;
      this.spinner.show();

      this.employeeService.GetProfileDetailsById(empId).subscribe(
        (res) => {
          this.employee = res.data;
          this.lastName = this.employee.lastName;
          this.firstName = this.employee.firstName;
          this.grade = this.employee.grade
          this.designation = this.employee.designation;
          this.employeeProfileBasicStatus = this.employee.employeeProfileStatus;
          this.employeeProfileStatus = this.getProfileStatus(this.employee.employeeProfileStatus)
          this.expDomains = this.employee.domains
          this.exp = this.employee.experience
          this.competency = this.employee.competencyName[0];
          this.competency1 = this.employee.competencyName.slice(1)
          this.subCompetencyName = this.employee.subCompetencyNames[0];
          this.subCompetencyName1 = this.employee.subCompetencyNames.slice(1);
          this.expDomains = this.employee.domains == null ? ['No Data'] : this.employee.domains;
          this.expYears = Math.floor(this.exp);
          this.expMonths = Math.round((this.exp - this.expYears) * 12);
          this.empExperience = parseInt(this.expYears) == 0 ? this.expMonths + " Months" : this.expYears + " Years " + this.expMonths + " Months";
          this.empAreaExps = this.employee.serviceAreas;
          this.primarySkills = this.employee.primarySkills.map(x => x.skill);
          for (let empAreaExp of this.empAreaExps) {
            let expYears = Math.floor(empAreaExp.experience);
            let expMonths = Math.round((empAreaExp.experience - expYears) * 12);
            if (expYears > 0 || expMonths > 0) {
              this.expAreas.push(empAreaExp.serviceArea)
              this.expAreaYear.push(expYears)
              this.expAreaMonth.push(expMonths)
            }
          }
          this.expAreaMonths = this.expAreaMonth;
          this.expAreaYears = this.expAreaYear;
          this.empAreaExps = this.expAreas == null ? ['No Data'] : this.expAreas;

          // Combine loop and map for efficiency
          // this.empAreaExp = this.expAreas?.map((item, index) => {
          //   let year = this.expAreaYears[index] === '1' ? " Year " : " Years ";
          //   return item + " - " + this.expAreaYears[index] + year + this.expAreaMonths[index] + " Months";
          // }).map(item => item.replace(",", "|")); // Replace commas with pipes

          // this.empAreaExp = this.expAreas?.map((item, index) => {
          //   let year = this.expAreaYears[index] === '1' ? " Year " : " Years ";
          //   return item + " - " + this.expAreaYears[index] + year + this.expAreaMonths[index] + " Months";
          // })

          for (var i = 0; i < this.expAreas.length; i++) {
            let year = this.expAreaYears[i] == '1' ? " Year " : " Years ";
            this.empAreaExp.push(this.expAreas[i] + " - " + this.expAreaYears[i] + year + this.expAreaMonths[i] + " Months" + " ")
          }

          this.empAreaAndExp = this.empAreaExp.length == 0 ? ['No Data'] : this.empAreaExp;
          this.spinner.hide();
          if (this.employee?.serviceAreas && this.employee?.serviceAreas.length > 0)
            this.employee.serviceAreas.forEach(s => {
              s.expYears = Math.floor(s.experience);
              s.expMonths = Math.round((s.experience - s.expYears) * 12);
            })
        },
        (error) => {
          console.error('Error fetching employee details:', error);
          this.loading = false;
          this.spinner.hide();
        }
      );
    }
  }

  getProfileStatus(status: number) {
    switch (status) {
      case 1: return "Approval Pending"
      case 2: return "Submission Pending"
      case 3: return "Approved"
      case 4: return "Rejected"
      default: return "Unknown"
    }
  }

  closeDialog() {
    this.dialog.closeAll();
  }

}
